// extracted by mini-css-extract-plugin
export default {"page":"MyProxiesPage_page__FhOts"};